var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { borderRadius } from '../theme/border-radius';
import React from 'react';
import styled from 'styled-components';
import cx from 'classnames';
const StyledKbd = styled.kbd `
  ${(props) => {
    var _a;
    console.log(props.size);
    return ((_a = props.size) !== null && _a !== void 0 ? _a : 12) > 12 ? 'padding: 8px 16px' : 'padding: 4px 8px';
}};
  background-color: ${() => 'var(--bg-color)'};
  color: ${() => 'var(--text-color-0)'};
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.5);
  border-radius: ${borderRadius.sm};
  cursor: pointer;
  font-weight: bolder;
  font-size: ${(props) => `${props.size}px`};
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
`;
export const Kbd = (_a) => {
    var { size = 12, className } = _a, props = __rest(_a, ["size", "className"]);
    return (React.createElement(StyledKbd, { className: cx('kbd', className), "data-role": "kbd", size: size }, props.children));
};
